const ClassesSchedulTable = ({ title, subtitle, season, scheduleRows, note }) => {
  return (
    <div className="class-calendar-section">
        <div className="calendar-header">
        <hr className="top-line" />
        <div className="calendar-header-title">
            <div className="header-title-text font-amaticsc">
                {title.en}
            </div>
            <p className="header-title-subtext font-kleeone">{title.jp}</p>
        </div>
        <hr className="bottom-line" />
        </div>
        <div className="calendar-content">
        <div className="content-title">
            <div className="title-text font-amaticsc-bold">{season}</div>
            <div className="title-sub-view">
            <p className="text1 font-amaticsc-bold">
                {subtitle.en}
            </p>
            <p className="text2 font-zenkurenaido">
                {subtitle.jp}
            </p>
            </div>
        </div>
        
        <table className="calendar-table">
            {/* Monday, Tuesday, Wednesday, Thursday, Friday */}
            <thead>
                <tr className="calendar-content-view">
                    {scheduleRows[0].items.map((cell, i) => (
                        <th key={i} className={`calendar-item ${i === 0 ? '' : 'purple'}`}>
                            <p className="text1 font-amaticsc-bold">{cell.title}</p>
                            <p className="text2 font-zenkurenaido">{cell.subtitle}</p>
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {scheduleRows.slice(1).map((rowObj, i) => (
                    <tr key={i} className="calendar-content-view">
                        {/* First column: time */}
                        <td className={`calendar-item time black-${i + 1}`}>
                        <p className="text3 font-amaticsc">{rowObj.items[0].title}</p>
                        <p className="text4 font-zenkurenaido">{rowObj.items[0].subtitle}</p>
                        </td>

                        {/* The rest of the columns */}
                        {rowObj.items.slice(1).map((cell, j) => (
                        <td key={j} className="calendar-item">
                            <p className="text5 font-amaticsc-bold">{cell.title}</p>
                            <p className="text6 font-zenkurenaido">{cell.subtitle}</p>
                        </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
        <div className="calendar-footer">
            <div className="calendar-footer-text font-outfit">
            <span className="footer-text-span">NOTE: </span>
                {note.en}
            </div>
            <div className="calendar-footer-text-jp font-zenkurenaido">
            <span className="footer-text-span">お知らせ: </span>
                {note.jp}
            </div>
        </div>
        </div>
    </div>
  )
}

export default ClassesSchedulTable;